import api from './api';

const documentService = {
  // Get all documents
  getDocuments: async (params = {}) => {
    try {
      const response = await api.get('/documents', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching documents:', error);
      throw error;
    }
  },

  // Get document by ID
  getDocumentById: async (id) => {
    try {
      const response = await api.get(`/documents/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching document ${id}:`, error);
      throw error;
    }
  },

  // Create new document
  createDocument: async (documentData) => {
    try {
      const formData = new FormData();
      
      Object.keys(documentData).forEach(key => {
        if (key === 'file') {
          formData.append('file', documentData.file);
        } else {
          formData.append(key, documentData[key]);
        }
      });

      const response = await api.post('/documents', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      console.error('Error creating document:', error);
      throw error;
    }
  },

  // Update document
  updateDocument: async (id, documentData) => {
    try {
      const response = await api.put(`/documents/${id}`, documentData);
      return response.data;
    } catch (error) {
      console.error(`Error updating document ${id}:`, error);
      throw error;
    }
  },

  // Delete document
  deleteDocument: async (id) => {
    try {
      const response = await api.delete(`/documents/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting document ${id}:`, error);
      throw error;
    }
  },

  // Get form options
  getFormOptions: async () => {
    try {
      const response = await api.get('/documents/form-options');
      return response.data;
    } catch (error) {
      console.error('Error fetching form options:', error);
      throw error;
    }
  },

  // Get suggested entity types
  getSuggestedEntityTypes: async () => {
    try {
      const response = await api.get('/documents/suggested-entity-types');
      return response.data;
    } catch (error) {
      console.error('Error fetching suggested entity types:', error);
      throw error;
    }
  },

  // Get entities by type
  getEntitiesByType: async (type) => {
    try {
      const response = await api.get('/documents/entities-by-type', {
        params: { type }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching entities by type:', error);
      throw error;
    }
  },

  // Get document statistics
  getDocumentStatistics: async () => {
    try {
      const response = await api.get('/documents/statistics');
      return response.data;
    } catch (error) {
      console.error('Error fetching document statistics:', error);
      throw error;
    }
  },

  // Get related entities
  getRelatedEntities: async (documentId) => {
    try {
      const response = await api.get('/documents/related-entities', {
        params: { document_id: documentId }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching related entities:', error);
      throw error;
    }
  },

  // Export documents
  exportDocuments: async (params = {}) => {
    try {
      const response = await api.get('/documents/export', {
        params,
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Error exporting documents:', error);
      throw error;
    }
  },

  // Get audit logs
  getAuditLogs: async (params = {}) => {
    try {
      const response = await api.get('/documents/audit-logs', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching audit logs:', error);
      throw error;
    }
  },

  // Get document alerts
  getDocumentAlerts: async () => {
    try {
      const response = await api.get('/documents/alerts');
      return response.data;
    } catch (error) {
      console.error('Error fetching document alerts:', error);
      throw error;
    }
  },

  // Get due reminders
  getDueReminders: async () => {
    try {
      const response = await api.get('/documents/due-reminders');
      return response.data;
    } catch (error) {
      console.error('Error fetching due reminders:', error);
      throw error;
    }
  },

  // Create reminder
  createReminder: async (documentId, reminderData) => {
    try {
      const response = await api.post(`/documents/${documentId}/reminders`, reminderData);
      return response.data;
    } catch (error) {
      console.error(`Error creating reminder for document ${documentId}:`, error);
      throw error;
    }
  },

  // Get reminders
  getReminders: async (documentId) => {
    try {
      const response = await api.get(`/documents/${documentId}/reminders`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching reminders for document ${documentId}:`, error);
      throw error;
    }
  },

  // Update reminder
  updateReminder: async (reminderId, reminderData) => {
    try {
      const response = await api.put(`/documents/reminders/${reminderId}`, reminderData);
      return response.data;
    } catch (error) {
      console.error(`Error updating reminder ${reminderId}:`, error);
      throw error;
    }
  },

  // Delete reminder
  deleteReminder: async (reminderId) => {
    try {
      const response = await api.delete(`/documents/reminders/${reminderId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting reminder ${reminderId}:`, error);
      throw error;
    }
  },

  // Mark reminder as sent
  markReminderAsSent: async (reminderId) => {
    try {
      const response = await api.post(`/documents/reminders/${reminderId}/mark-sent`);
      return response.data;
    } catch (error) {
      console.error(`Error marking reminder ${reminderId} as sent:`, error);
      throw error;
    }
  }
};

export default documentService;